import { ArrowLeft } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowLeftIcon = createLucideIcon(ArrowLeft);
